// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"137": "__federation_expose_workshopRouter","257": "__federation_expose_adminLocationsRouter",}[chunkId] || chunkId) + "." + {"137": "c2b9fcb99e792e91","257": "c1dcfe36d3519ffe","472": "51c9b2387fc4a3a5",}[chunkId] + ".css"
}